<template>
  <vx-tooltip :text="$t('login_as', { name: username })">
    <vs-button color="warning" type="border" icon-pack="feather" icon="icon-user" size="small" @click.prevent="impersonify"></vs-button>
  </vx-tooltip>
</template>

<script>
import http from '@/requests/http'
import UserHelper from '@/helpers/user'

export default {
  name: 'IdentityLoginButton',
  props: {
    id: {
      required: true,
      type: Number
    },
    username: {
      required: true,
      type: String
    }
  },
  computed: {
    identity () {
      return this.$store.getters.identity
    },
    hasIdentity () {
      return this.identity !== null && this.identity !== ''
    }
  },
  methods: {
    async impersonify () {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_login_as_the_selected_user'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        try {
          this.$store.dispatch('setIsLoading', true)

          const response = await http.post('identity/login', { id: this.id })

          // await this.$store.dispatch('removeToken') // TODO: Check on why if token is removed, components get remounted.

          if (!this.hasIdentity) {
            await this.$store.dispatch('setIdentity', this.$store.getters.userInfo.id) // Set current identity. do not handle identity tree
          } else {
            await this.$store.dispatch('setIdentity', this.identity) // Re-set identity
          }

          const userData = new UserHelper(response)
          await this.$store.dispatch('setToken', userData.getAccessToken())
          await this.$store.dispatch('setRefreshToken', userData.getRefreshToken())
          await this.$store.dispatch('setUserInfo', userData.getUserData())

          window.location.replace(userData.getRedirectUrl())
        } catch (e) {
          // TODO: Add custom loader for identity login
          this.$store.dispatch('setIsLoading', false)

          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
